import React from 'react'
import {
   Link as RouterLink
} from 'react-router-dom'
import {
   Link,
   Events,
   scrollSpy,
} from 'react-scroll'
import PropTypes from "prop-types";

class Navigation extends React.Component {

   constructor() {
      super()
      this.state = {
         isOpened: false,
      }
   }

   static propTypes = {
      isHome: PropTypes.bool
   };

   componentDidMount() {
      Events.scrollEvent.register('begin', function(to, element) {});
      Events.scrollEvent.register('end', function(to, element) {});
      scrollSpy.update();
   }

   componentWillUnmount() {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
   }

   toggleMenu() {
      this.setState({
         isOpened: this.state.isOpened ? false : true
      });
   }

   closeMenu() {
      this.setState({
         isOpened: false
      });
   }

   render() {

      const navigationScroll = (
         <ul>
              <li>
                <Link
                  activeClass="active"
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={this.closeMenu.bind(this)}>
                  <span>Startseite</span>
               </Link>
             </li>
               <li>
                 <Link
                    activeClass="active"
                    to="skills"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                    onClick={this.closeMenu.bind(this)}>
                    <span>Was wir können</span>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={this.closeMenu.bind(this)}>
                  <span>Kontakt</span>
               </Link>
             </li>
         </ul>
      );

      const navigationDirect = (
         <ul>
            <li><RouterLink to="/" onClick={this.closeMenu.bind(this)}><span>Startseite</span></RouterLink></li>
            <li><RouterLink to="/" onClick={this.closeMenu.bind(this)}><span>Was wir können</span></RouterLink></li>
            <li><RouterLink to="/" onClick={this.closeMenu.bind(this)}><span>Kontakt</span></RouterLink></li>
         </ul>
      );


      return (<div>

         <div id="nav-container">
            <div id="nav-menu-top">
               <a href="/" onClick={this.closeMenu.bind(this)} id="nav-logo"> </a>
               <div id="nav-menu-button" className={this.state.isOpened ? "open" : ""} onClick={this.toggleMenu.bind(this)}></div>
            </div>
            <div id="nav-menu" className={this.state.isOpened ? "open" : ""}>
               {this.props.isHome ? navigationScroll : navigationDirect}
            </div>
         </div>
      </div>);
   }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js